'use client';

import { useMemo } from 'react';
const useOAuth = (searchParams, client) => {
  const responseType = useMemo(() => {
    var _a;
    if (!searchParams.has('response_type')) return 'code';
    return (_a = searchParams.get('response_type')) !== null && _a !== void 0 ? _a : '';
  }, [searchParams]);
  const state = useMemo(() => {
    var _a_0;
    if (!searchParams.has('state')) return '';
    return (_a_0 = searchParams.get('state')) !== null && _a_0 !== void 0 ? _a_0 : '';
  }, [searchParams]);
  const redirectUri = useMemo(() => {
    var _a_1;
    if (!searchParams.has('redirect_uri')) return client.redirectUris[0];
    return (_a_1 = searchParams.get('redirect_uri')) !== null && _a_1 !== void 0 ? _a_1 : '';
  }, [searchParams, client.redirectUris]);
  const scope = useMemo(() => {
    var _a_2;
    if (!searchParams.has('scope')) return client.scopes.join(' ');
    return (_a_2 = searchParams.get('scope')) !== null && _a_2 !== void 0 ? _a_2 : '';
  }, [searchParams, client.scopes]);
  return {
    responseType,
    scope,
    state,
    redirectUri
  };
};
export default useOAuth;